/* tslint:disable */
/* eslint-disable */
/**
 * Unnamed Galvyn API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ApiErrorResponse,
  ChangePasswordRequest,
  CreatePasswordWithTotpRequest,
  CreateTotpRequest,
  CreateWebauthnRequest,
  FormResultForNullAndAuthenticateTailscaleDeviceError,
  FormResultForNullAndChangePasswordErrors,
  FormResultForNullAndCreatePasswordWithTotpErrors,
  FormResultForNullAndCreateTotpErrors,
  FormResultForNullAndSetPasswordErrors,
  GetCredentialsResponse,
  GetUserAccessExpirationResponse,
  SetPasswordRequest,
  SimpleUser,
} from '../models/index';

export interface AuthenticateTailscaleDeviceRequest {
    tailscale_token: string;
}

export interface ChangePasswordOperationRequest {
    ChangePasswordRequest?: ChangePasswordRequest;
}

export interface CompleteWebauthnRequest {
    body?: object;
}

export interface CreateNewPasswordRequest {
    SetPasswordRequest?: SetPasswordRequest;
}

export interface CreatePasswordWithTotpOperationRequest {
    CreatePasswordWithTotpRequest?: CreatePasswordWithTotpRequest;
}

export interface CreateTotpOperationRequest {
    CreateTotpRequest?: CreateTotpRequest;
}

export interface CreateWebauthnOperationRequest {
    CreateWebauthnRequest?: CreateWebauthnRequest;
}

export interface DeleteTotpRequest {
    uuid: string;
}

export interface DeleteWebauthnRequest {
    uuid: string;
}

/**
 * 
 */
export class DefaultApi extends runtime.BaseAPI {

    /**
     * Complete tailscale login
     * Complete tailscale login
     */
    async authenticateTailscaleDeviceRaw(requestParameters: AuthenticateTailscaleDeviceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FormResultForNullAndAuthenticateTailscaleDeviceError>> {
        if (requestParameters['tailscale_token'] == null) {
            throw new runtime.RequiredError(
                'tailscale_token',
                'Required parameter "tailscale_token" was null or undefined when calling authenticateTailscaleDevice().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/frontend/v1/user/auth/authenticate-tailscale-device/{tailscale_token}`.replace(`{${"tailscale_token"}}`, encodeURIComponent(String(requestParameters['tailscale_token']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Complete tailscale login
     * Complete tailscale login
     */
    async authenticateTailscaleDevice(requestParameters: AuthenticateTailscaleDeviceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FormResultForNullAndAuthenticateTailscaleDeviceError> {
        const response = await this.authenticateTailscaleDeviceRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Change password for user
     * Change password for user
     */
    async changePasswordRaw(requestParameters: ChangePasswordOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FormResultForNullAndChangePasswordErrors>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/frontend/v1/user/credentials/change-password`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['ChangePasswordRequest'],
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Change password for user
     * Change password for user
     */
    async changePassword(requestParameters: ChangePasswordOperationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FormResultForNullAndChangePasswordErrors> {
        const response = await this.changePasswordRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Complete the webauthn challenge for an existing user
     * Complete the webauthn challenge for an existing user
     */
    async completeWebauthnRaw(requestParameters: CompleteWebauthnRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/frontend/v1/user/credentials/complete-webauthn`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['body'] as any,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Complete the webauthn challenge for an existing user
     * Complete the webauthn challenge for an existing user
     */
    async completeWebauthn(requestParameters: CompleteWebauthnRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.completeWebauthnRaw(requestParameters, initOverrides);
    }

    /**
     * Create new password for user
     * Create new password for user
     */
    async createNewPasswordRaw(requestParameters: CreateNewPasswordRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FormResultForNullAndSetPasswordErrors>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/frontend/v1/user/credentials/create_new_password`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['SetPasswordRequest'],
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Create new password for user
     * Create new password for user
     */
    async createNewPassword(requestParameters: CreateNewPasswordRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FormResultForNullAndSetPasswordErrors> {
        const response = await this.createNewPasswordRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async createPasswordWithTotpRaw(requestParameters: CreatePasswordWithTotpOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FormResultForNullAndCreatePasswordWithTotpErrors>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/frontend/v1/user/credentials/create-password-with-totp`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['CreatePasswordWithTotpRequest'],
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async createPasswordWithTotp(requestParameters: CreatePasswordWithTotpOperationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FormResultForNullAndCreatePasswordWithTotpErrors> {
        const response = await this.createPasswordWithTotpRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async createTotpRaw(requestParameters: CreateTotpOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FormResultForNullAndCreateTotpErrors>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/frontend/v1/user/credentials/create-totp`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['CreateTotpRequest'],
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async createTotp(requestParameters: CreateTotpOperationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FormResultForNullAndCreateTotpErrors> {
        const response = await this.createTotpRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Adds a webauth key for an existing user
     * Adds a webauth key for an existing user
     */
    async createWebauthnRaw(requestParameters: CreateWebauthnOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<object>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/frontend/v1/user/credentials/create-webauthn`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['CreateWebauthnRequest'],
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Adds a webauth key for an existing user
     * Adds a webauth key for an existing user
     */
    async createWebauthn(requestParameters: CreateWebauthnOperationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<object> {
        const response = await this.createWebauthnRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async deletePasswordRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/frontend/v1/user/credentials/delete-password`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async deletePassword(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deletePasswordRaw(initOverrides);
    }

    /**
     */
    async deleteTotpRaw(requestParameters: DeleteTotpRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['uuid'] == null) {
            throw new runtime.RequiredError(
                'uuid',
                'Required parameter "uuid" was null or undefined when calling deleteTotp().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/frontend/v1/user/credentials/delete-totp/{uuid}`.replace(`{${"uuid"}}`, encodeURIComponent(String(requestParameters['uuid']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async deleteTotp(requestParameters: DeleteTotpRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteTotpRaw(requestParameters, initOverrides);
    }

    /**
     */
    async deleteWebauthnRaw(requestParameters: DeleteWebauthnRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['uuid'] == null) {
            throw new runtime.RequiredError(
                'uuid',
                'Required parameter "uuid" was null or undefined when calling deleteWebauthn().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/frontend/v1/user/credentials/delete-webauthn/{uuid}`.replace(`{${"uuid"}}`, encodeURIComponent(String(requestParameters['uuid']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async deleteWebauthn(requestParameters: DeleteWebauthnRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteWebauthnRaw(requestParameters, initOverrides);
    }

    /**
     * Retrieves the user\'s current credentials
     * Retrieves the user\'s current credentials
     */
    async getCredentialsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetCredentialsResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/frontend/v1/user/credentials/get-credentials`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Retrieves the user\'s current credentials
     * Retrieves the user\'s current credentials
     */
    async getCredentials(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetCredentialsResponse> {
        const response = await this.getCredentialsRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async getMyUserRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SimpleUser>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/frontend/v1/user/auth/me`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async getMyUser(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SimpleUser> {
        const response = await this.getMyUserRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get the expiration date of the user\'s access
     * Get the expiration date of the user\'s access
     */
    async getUserAccessExpirationRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetUserAccessExpirationResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/frontend/v1/user/local-user/access-expiration`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Get the expiration date of the user\'s access
     * Get the expiration date of the user\'s access
     */
    async getUserAccessExpiration(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetUserAccessExpirationResponse> {
        const response = await this.getUserAccessExpirationRaw(initOverrides);
        return await response.value();
    }

}
